import { render, staticRenderFns } from "./chartTest.vue?vue&type=template&id=74b745b8"
import script from "./chartTest.vue?vue&type=script&lang=js"
export * from "./chartTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports